// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/f4a90f07870c423099dd.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"162f7bca1c0779148553","155":"a0b07ad481f31925a523","156":"2e95d648445a5d0992e6"}[chunkId] + ".chunk.js";
};